import React, { useContext } from 'react'
import { Routes, Route } from "react-router-dom";
import Login from '../Authentication/Login';
import Home from '../Pages/Home';
import QCSHome from '../Pages/QrCodeScanning/QCSHome';
import ProductsListingRedem from '../Pages/Redemption/ProductsListingRedem';
import ProductView from '../Pages/Redemption/ProductView';
import Cart from '../Pages/Shopping/Cart';
import Checkout from '../Pages/Shopping/Checkout';
import OrderPlacedSuccess from '../Pages/Shopping/OrderPlacedSuccess';
import ProductsListing from '../Pages/Shopping/ProductsListing';
import Profile from '../Pages/User/Profile';
import AuthContext from '../Store/AuthContext';

const MainNavigator = () => {
    const authCtx = useContext(AuthContext);
    let isLoggedIn = authCtx.isLoggedIn;

    if (!isLoggedIn) {
        return (
            <Routes>
                <Route path="*" element={<Home />}></Route>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/:storeKey" element={<Home />}></Route>
                <Route path="/:storeKey/home" element={<Home />}></Route>
                <Route path="/login/:landingPage" element={<Login />}></Route>
                <Route path="/:storeKey/shop" element={<ProductsListing />}></Route>
                <Route path="/qr-scanning" element={<QCSHome />}></Route>
                <Route path="/redeem" element={<ProductsListingRedem />}></Route>
                <Route path="/redeem/:productIdentifier" element={<ProductView />}></Route>

            </Routes>
        )
    } else {
        return (
            <Routes>
                <Route path="*" element={<Home />}></Route>
                <Route path="/:storeKey" element={<Home />}></Route>
                <Route path="/:storeKey/home" element={<Home />}></Route>
                <Route path="/:storeKey/shop" element={<ProductsListing />}></Route>
                <Route path="/:storeKey/cart" element={<Cart />}></Route>
                <Route path="/:storeKey/checkout" element={<Checkout />}></Route>
                <Route path="/order-placed/success/:orderIdentifier" element={<OrderPlacedSuccess />}></Route>
                <Route path="/qr-scanning" element={<QCSHome />}></Route>
                <Route path="/redeem" element={<ProductsListingRedem />}></Route>
                <Route path="/redeem/:productIdentifier" element={<ProductView />}></Route>
                <Route path="/profile" element={<Profile />}></Route>
            </Routes>
        )
    }
}

export default MainNavigator